import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import axios from 'axios';
import PhoneInput from 'react-phone-number-input';
// import Parser from 'html-react-parser';
import useToggle from '../../../Hooks/useToggle';
import BackToTop from '../../BackToTop';
// import Footer from '../../../Helper/Footer';
import Drawer from '../../Mobile/DrawerInstitute';

import Header from '../../Helper/HeaderInstitute';
import Footer from '../../Helper/FooterInstitute';

import { BASEAPIURL, uploadFileAPI } from '../../../config';
import './bookaclass.css';

function BookTeamLearn() {
    const { t } = useTranslation();
    const [drawer, drawerAction] = useToggle(false);
    const [message, setMessage] = useState({ status: 0, value: "", sent: false });
    const [formData, setFormData] = useState({ fName: '', lName: '', email:'', mobile: '', message: '' });
    function setPhoneNumber(v) {
        setFormData({ ...formData, mobile: v });
    }

    function closeshowSent() {
        setMessage({  ...message, sent: false });
    }

    async function handleSubmit() {
        try {
            const url = `${BASEAPIURL}/institute/enquiry/send-career-enquiry`;
            const config = {
                headers: {
                    'content-type': 'application/json', // multipart/form-data
                },
            };
            axios.post(url, formData, config).then((response) => {
                if (response.data.status === 1) {
                    setMessage({ ...message, value: response.data.message, status: response.data.status, sent: true });
                    document.getElementById('Inst-Enq-Form').reset();
                    setFormData({ fName: '', lName: '', email:'', mobile: '', message: '', resume: '' });
                } else {
                    setMessage({ ...message, value: response.data.message, status: response.data.status });
                }
            });
        } catch (err) {
            setMessage({ ...message, value: err.message, status: 0, sent: false });
        }
    }

    async function uploadFile(e, file) {
        e.preventDefault();
        setFormData({ ...formData, apiCall: true });
        try {
            const data = await uploadFileAPI(file, 'careersResumes');
            if (data && data.file && data.file !== 0) {
                setFormData({ ...formData, apiCall: false, resume: data.file});
            } else {
                setMessage({ ...message, status: 0, value: data.message })
                setFormData({ ...formData, apiCall: false});
            }
        } catch (ex) {
            setMessage({ ...message, status: 0, value: ex.message })
            setFormData({ ...formData, apiCall: false});
        }
    }

    function getdefaultCountry() {
        let send = 'IN';
        const country_name = localStorage.getItem('country_name');
        if (country_name === 'India') {
            send = 'IN';
        }
        if (country_name === 'United Arab Emirates') {
            send = 'AE';
        }
        return send;
    }

    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <Header drawer={drawer} action={drawerAction.toggle} />
            <>
                {message.sent && (
                    <div>
                        <div className="mfp-bg mfp-ready"></div>
                        <div
                            className="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready"
                            tabIndex="-1"
                            style={{ overflow: ' hidden auto' }}
                        >
                            <div className="mfp-container mfp-s-ready mfp-iframe-holder">
                                <div className="mfp-content" style={{ maxWidth: 'max-content' }}>
                                    <div className="mfp-iframe-scaler-old">
                                        <button
                                            onClick={closeshowSent}
                                            title="Close (Esc)"
                                            type="button"
                                            className="mfp-close"
                                        >
                                            x
                                        </button>
                                    </div>
                                    <div
                                        className="mfp-iframe p-4 text-center"
                                        style={{ background: '#fff' }}
                                    >
                                        <i
                                            // src={`${IMGBASEAPIURL}institute/bookaclass.svg`}
                                            // alt="Enquiry Sent"
                                            className="mb-3 fa fa-check fa-2x"
                                        />
                                        <h3 className="pagetitle mb-3">Enquiry Sent</h3>
                                        <h4 className="mt-3 mb-3">
                                            We will get back to you soon.
                                        </h4>
                                    </div>
                                </div>
                                <div className="mfp-preloader">Loading...</div>
                            </div>
                        </div>
                    </div>
                )}
                <section
                    className="pt-80 pb-80"
                    style={{
                        backgroundImage: `url('/images/career.png')`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center center',
                        backgroundAttachment: 'fixed',
                        backgroundRepeat: 'no-repeat',
                    }}
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="ry_instr_shadow" style={{ background: '#ffffffd6' }}>
                                    <div className="row align-items-center">
                                        <div className="col-md-6">
                                            <div className="m-4 p-4">
                                                {/* <h3 className="">Learn Together, Grow Together</h3> */}
                                                
                                                {t('langCode') === 'en' && (
                                                    <>
                                                        <h5 className="mt-0" style={{ lineHeight: '1.8rem' }}>
                                                            Do You Dream in Ideas and Think in Impact?
                                                        </h5>
                                                        <p className="mt-4">
                                                            At <b>Acumen Glow</b>, we don't just build learning experiences—we craft futures. If you're passionate about <b>online education, obsessed with creativity, and inspired by the idea of shaping young minds</b> beyond textbooks, we want to hear from you.
                                                        </p>
                                                        <p className="mt-4">
                                                            We're on a mission to spark curiosity, build confidence, and empower youth and young professionals through meaningful, real-world learning. Whether you're a content creator, digital strategist, educator, or ed-tech enthusiast—if you can dream it, and more importantly, do it—Acumen Glow is your platform.
                                                        </p>
                                                        <p className="mt-4">
                                                            Ready to Glow with us?
                                                        </p>
                                                        <h6 className="mt-4" style={{ lineHeight: '1.8rem' }}>
                                                            Fill out the form and let's co-create the future of learning.
                                                        </h6>
                                                    </>
                                                )}

                                                
                                                {t('langCode') === 'fr' && (
                                                    <>
                                                        <h5 className="mt-0" style={{ lineHeight: '1.8rem' }}>
                                                            Vous rêvez en idées et pensez en impact ?
                                                        </h5>
                                                        <p className="mt-4">
                                                            Chez Acumen Glow, nous ne créons pas simplement des expériences d'apprentissage — nous façonnons des avenirs.Si vous êtes passionné par l'éducation en ligne, animé par la créativité et inspiré par l'idée de former les esprits au-delà des manuels, nous voulons vous entendre.
                                                        </p>
                                                        <p className="mt-4">
                                                            Nous avons pour mission d'éveiller la curiosité, de renforcer la confiance et d'autonomiser les jeunes et les jeunes professionnels grâce à un apprentissage concret et porteur de sens. Que vous soyez créateur de contenu, stratège digital, éducateur ou passionné de technologie éducative — si vous pouvez l'imaginer et surtout le réaliser — Acumen Glow est votre terrain de jeu.
                                                        </p>
                                                        <p className="mt-4">
                                                            Prêt(e) à briller avec nous ?
                                                        </p>
                                                        <h6 className="mt-4" style={{ lineHeight: '1.8rem' }}>
                                                            Remplissez le formulaire et co-créons ensemble l'avenir de l'apprentissage.
                                                        </h6>
                                                    </>
                                                )}

                                                {t('langCode') === 'pt' && (
                                                    <>
                                                        <h5 className="mt-0" style={{ lineHeight: '1.8rem' }}>
                                                            Sonha em Ideias e Pensa em Impacto?
                                                        </h5>
                                                        <p className="mt-4">
                                                            Na Acumen Glow, não criamos apenas experiências de aprendizagem — moldamos futuros.
                                                            <br />
                                                            Se é apaixonado por educação online, movido pela criatividade e inspirado pela ideia de formar mentes jovens para além dos livros, queremos conhecê-lo.
                                                        </p>
                                                        <p className="mt-4">
                                                            Estamos numa missão de despertar a curiosidade, fortalecer a confiança e capacitar jovens e jovens profissionais através de uma aprendizagem significativa e ligada ao mundo real.
                                                            <br />
                                                            Se é criador de conteúdos, estratega digital, educador ou entusiasta de edtech — se consegue sonhá-lo, e mais importante ainda, realizá-lo — a Acumen Glow é o seu palco.

                                                        </p>
                                                        <p className="mt-4">
                                                            Pronto para brilhar connosco?
                                                        </p>
                                                        <h6 className="mt-4" style={{ lineHeight: '1.8rem' }}>
                                                            Preencha o formulário e vamos co-criar o futuro da aprendizagem.
                                                        </h6>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <form
                                                id="Inst-Enq-Form"
                                                className="bookaclass_frm p-4"
                                                onClick={() => {
                                                    setMessage({ ...message, value: "" });
                                                }}
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    handleSubmit();
                                                }}
                                                style={{
                                                    background: '#546a2c82'
                                                }}
                                            >
                                                {/* <img src="assets/img/bac_top.png" alt="Acumen Glow" /> */}

                                                <h5 className="text-center text-white mt-3 mb-0">
                                                    Please fill out the form
                                                </h5>

                                                <div className="row mr-3 ml-3">
                                                    <div className="col-md-6 pr-1 pl-1 mt-3">
                                                        <div className="form-group  mb-2">
                                                            <label>First Name*</label>
                                                            <input
                                                                type="text"
                                                                name="fName"
                                                                placeholder="First name"
                                                                className="form-control"
                                                                required
                                                                value={formData.fName}
                                                                onChange={(e) => {
                                                                    setFormData({ ...formData, fName: e.target.value });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 pr-1 pl-1 mt-3">
                                                        <div className="form-group  mb-2">
                                                            <label>Last Name*</label>
                                                            <input
                                                                type="text"
                                                                name="lName"
                                                                placeholder="Last name"
                                                                className="form-control"
                                                                required
                                                                value={formData.lName}
                                                                onChange={(e) => {
                                                                    setFormData({ ...formData, lName: e.target.value });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mr-3 ml-3">
                                                    <div className="col-md-6  mt-3 pr-1 pl-1">
                                                        <div className="form-group  mb-2">
                                                            <label>Email*</label>
                                                            <input
                                                                type="email"
                                                                name="email"
                                                                placeholder="Email"
                                                                className="form-control"
                                                                required
                                                                value={formData.email}
                                                                onChange={(e) => {
                                                                    setFormData({ ...formData, email: e.target.value });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6  mt-3 pr-1 pl-1">
                                                        <div className="form-group mb-2">
                                                            <label>Phone Number*</label>
                                                            <PhoneInput
                                                                international
                                                                className="form-control"
                                                                name="phonenumber"
                                                                value={formData.mobile}
                                                                onChange={setPhoneNumber}
                                                                required="required"
                                                                defaultCountry={getdefaultCountry()}
                                                                style={{ position: 'relative' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mr-3 ml-3">
                                                    <div className="col-md-12 mt-3 pr-1 pl-1">
                                                        <div><b>Resume</b> (PDF or Docs File)</div>
                                                        <input
                                                            type="file"
                                                            name="image"
                                                            accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                            className="form-control"
                                                            onChange={(e) => {
                                                                if (e.target.files && e.target.files[0]) {
                                                                    uploadFile(e, e.target.files[0], e.target.files[0].name);
                                                                }
                                                            }}
                                                            style={{
                                                                lineHeight: '20px',
                                                                paddingBottom: '35px',
                                                                paddingTop: '10px',
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="col-md-12 mt-3 pr-1 pl-1">
                                                        <div className="form-group  mb-2">
                                                            <label>Message</label>
                                                            <textarea
                                                                type="date"
                                                                name="notes"
                                                                placeholder="Additional notes"
                                                                className="form-control"
                                                                value={formData.message}
                                                                onChange={(e) => {
                                                                    setFormData({ ...formData, message: e.target.value });
                                                                }}
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>

                                                {formData.apiCall && (
                                                    <div className="text-center">
                                                        <img
                                                            className="mt-2"
                                                            src="/loader.gif"
                                                            alt=""
                                                            style={{ maxWidth: "35px" }}
                                                        />
                                                    </div>
                                                )}

                                                <div className="row mr-3 ml-3">
                                                    <div className="col-md-12 pr-1 pl-1">
                                                        <div className="form-group  mb-2">
                                                            <div
                                                                className={`message mt-3 ${message.value ? '' : 'd-none'} alert alert-${message.status ? 'success' : 'danger'}`}
                                                            >
                                                                {message.value}
                                                            </div>
                                                            <button
                                                                type="submit"
                                                                className="btn mt-3 btn-docsta-instructor"
                                                            >
                                                                Send Enquiry
                                                            </button>
                                                            <small>
                                                                Field with * are required to complete the request.
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <img src="assets/img/bac_foot.png" alt="Acumen Glow" className="mt-4" /> */}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-1"></div>
                        </div>
                    </div>
                </section>
            </>
            <Footer className="appie-footer-about-area" />
            <BackToTop />
        </>
    );
}

export default BookTeamLearn;
